export function splitNode(document, selection, root) {
  let range = selection.getRangeAt(0);
  let { firstChild, lastChild } = root;

  let previousRange = document.createRange();
  previousRange.setStartBefore(firstChild);
  previousRange.setEnd(range.startContainer, range.startOffset);

  let nextRange = document.createRange();
  nextRange.setStart(range.endContainer, range.endOffset);
  nextRange.setEndAfter(lastChild);

  return {
    previous: previousRange,
    current: range,
    next: nextRange,
  };
}
